import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  margin-top: 16px;
  margin-left: -53px;

  @media only screen and (max-width: 767px) {
    max-width: 288px;
    margin-left: calc((100% - 68px - 288px) / 2);
  }
`;
